import { render, staticRenderFns } from "./AccountTab.vue?vue&type=template&id=24aeab64&scoped=true"
import script from "./AccountTab.vue?vue&type=script&lang=js"
export * from "./AccountTab.vue?vue&type=script&lang=js"
import style0 from "./AccountTab.vue?vue&type=style&index=0&id=24aeab64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aeab64",
  null
  
)

export default component.exports